// extracted by mini-css-extract-plugin
module.exports = {"container":"InformationList-module__container___1I8RY","info":"InformationList-module__info___2LsEs","link":"InformationList-module__link___2oMM2"};